export enum ChangeRequestStatusData {
  Draft = 10,
  Pending = 20,
  Approved = 30,
  Rejected = 40
}

export enum AssetTypeIds {
  _3rd_party_Pipeline = 1,
  Allocation = 2,
  Artificial_Lift_Gas_Lines = 3,
  Building = 4,
  Completion = 5,
  Compressor_Facility = 6,
  Deficiency_Fees = 7,
  Department = 8,
  Electrical_Facility = 9,
  Flowline = 10,
  Fuel_Gas_Lines = 11,
  Fuel_Station = 12,
  Gas_Plant = 13,
  Gas_Plant_Section = 14,
  Gathering_System = 15,
  Geological_and_Geophysical = 16,
  Injection_Well = 17,
  Innovations = 18,
  Inventory_Yard = 19,
  Lease = 20,
  Miscellaneous_Facility = 21,
  Oil_and_Gas_Well = 22,
  Other = 23,
  Pioneer_Water_Management = 24,
  Pod = 25,
  Pond = 26,
  Property_Accounting = 27,
  Prospect = 28,
  Sand_Plant = 29,
  Sand_Plant_Section = 30,
  Sustainable_Development = 31,
  SWD_Facilities = 32,
  SWD_Wells = 33,
  SWD_Third_Party_User = 34,
  Tank_Battery = 35,
  Treatment_Facility = 36,
  Unit = 37,
  Unit_Zone_Tract = 38,
  Water_Supply_Facility = 39,
  Water_Supply_Well = 40,
  Water_Transfer_Lines = 41,
  Well_Pad = 42,
  Wellhead_Compressors = 43,
  Yards = 44,
  Wells = 45,
}

export enum AssetSuperTypeId {
  Facility = 10,
  Pipeline = 20,
  PipelineNetwork = 30,
  PWM_Facility = 40,
  OG_Well = 50,
  Other = 60,
  NotCategorized = 70,
  SWD_Injection_Well = 80,
  WaterWell = 90,
  Yards_Buildings = 100,
  PPID = 110
}

export enum ProjectTypeId {
  TankBattery = 1,
  SaltWaterDisposal = 2,
  PlugAndAbandon = 3,
  HeavyEquipment = 4,
  WellConnect = 5,
  WaterRecycle = 6,
  WaterSourceFacility = 7,
  OtherFacConstrOps = 8,
  DrillWaterWell = 9,
  CompleteWaterWell = 10,
  ElectricalInfrastructure = 11,
  SCADAIInstrumentation = 12,
  Surface = 13,
  PlugAndAbandonWater = 14,
  CompleteInjectionWell = 15,
  PondBuildPNRWater = 16,
  PondBuild = 17,
  PumpingStation = 18,
  Pipeline = 19,
  GasPlant = 20,
  DrillOilGasWell = 21,
  CompleteOilGasWell = 22,
  DrillInjectionWell = 23,
  Compression = 24,
  Flowback = 25,
  EnvironmentalRemediation = 26,
  FutureSiteRestoration = 27,
  LandImprovement = 28,
  MeteringFacilities = 29,
  InformationTechnology = 30,
  Innovation = 31,
  ITMaintenanceAndSupport = 32,
  LandPreDrilling = 33,
  LandAcqOilAndGas = 34,
  LandAcqYardsAndBldgs = 35,
  LS2SPUD = 36,
  OBODrilling = 37,
  OBOFacilities = 38,
  OBOOperations = 39,
  PlantUpgradesAndEquip = 40,
  Science = 41,
  SandExpense = 42,
  SustainableDevelopment = 43,
  TechnicalStudies = 44,
  Workover = 45,
  WorkoverRefrac = 46,
  YardsAndBuildingsConstr = 47,
  CapitalizedGandA = 48,
  GeologicalAndGeophysical = 49,
  PondBuildOther = 50,
  PlugAndAbandonPNRWater = 51,
  DrillWaterWellPWM = 52,
  PadConstruction = 57,
  CompletePostStimOAG = 58,
  CompleteStimOAG = 59,
  Flowline = 60,
  WellPadFacility = 61,
  WellHookup = 62,
  PWMEnvRemediation = 66,
  GeneralEnvPWM = 69
}

export enum FunctionIds {
  Facilities = 1,
  Drilling = 2,
  Completions = 3,
  Corporate = 4,
  Environmental = 5,
  Information_Technology = 6,
  Integrated_Services = 8,
  Land = 9,
  Operations = 10,
  Corporate_Eng = 13
}

export enum AssetTeamId {
  CORP = 1,
  VIS = 2,
  PAT = 3,
  WAT = 4,
  STAT = 5,
  SWAT = 6,
  PIG = 7,
  DEL = 8
}

export enum ProjectSubTypeId {
  DrillHorizontal = 12,
  DrillVertical = 13,
  Horizontal = 24,
  InitialBuild = 129,
  Expansion = 130,
  Compressor = 131
}

export enum PadConstructionProjectSubTypeId {
  PadConstruction = 113,
  SWD = 114,
  General = 115,
  PitRemediation = 1152,
  TankBattery = 1253
}

export enum SWDFacilityProjectSubTypeId {
    ProducedWaterBoosterStation = 1171,
    ProducedWaterPipeline = 1172,
    SWDFacility = 1173
}

export enum ProjectSuperTypeId {
  Facilities = 1,
  HeavyEquipment = 2,
  IT = 3,
  Land = 4,
  OBO = 5,
  TechnicalStudies = 6,
  Well = 7,
  YardsBuildings = 8
}

export enum ProjectStatusId {
  Draft = 1,
  Preliminary = 2,
  Pending = 3,
  Active = 4,
  Closing = 5,
  Closed = 6,
  Reactivated = 7,
  OnHold = 8,
  Cancelled = 9
}

export enum ProjectEstimateStatus {
  Draft = 1,
  LatestPublished = 2,
  PreviouslyPublished = 3
}

export enum ProjectEstimateRecordType {
  Afe = 1,
  Pcr = 2,
  AfeRevision = 3,
}

export enum ModuleEnum {
  Asset = 1,
  WellDetails = 2,
  MultiWell = 3,
  Pipeline = 4,
  MultiAsset = 5,
  CostCenter = 6,
  Map = 7,
  MultiWellSwdVertical = 8
}

export enum DefaultScheduleTemplateNameId {
  DrillHorizontal = 10,
  CompletionHorizontal = 100,
  DrillVertical = 200,
  General = 10000,
  CompleteStimOAG = 100,
  CompletePostStimOAG = 230,
  WellConnectFlowline = 250,
  WellConnectWellHookup = 270,
  WellConnectWellPadFacility = 260
}

export enum ProjectDivision {
  PERMIAN_JV_HORIZONTALS = 5,
  PERMIAN_JV_VERTICALS = 6,
  PERMIAN_NON_JV_HORIZONTALS = 7,
  PERMIAN_NON_JV_VERTICALS = 8,
  DELAWARE_BASIN_HORIZONTALS = 21,
  DELAWARE_BASIN_VERTICALS = 22
}

export enum eQuantityTypes {
  Number = 1,
  Calculation = 2,
  Parameter = 3,
  ScheduleDuration = 4,
  PropertyPicker = 5
}

export enum eCostCodeCostTypes {
  Tax = 2262,
  Contingency = 3071
}

export enum ProjectResourceItemType {
  ScopingScreen = 1,
  StandardConfiguration = 2,
  ManualItem = 3,
  ManualCost = 4
}

export enum FuelType {
  CNG = 1,
  DGB = 2,
  Diesel = 3,
  ElectricGrid = 4,
  FieldGas = 5
}

export enum ConstructionTypes {
  Initial = 1,
  Expansion = 2,
  Upgrade = 3,
  Miscellaneous = 4,
  NA = 5,
  Small = 6,
  Medium = 7,
  Large = 8,
  NotScoped = 9
}

export enum TankBatteryDesign {
  Large = 1,
  Medium = 2,
  Small = 3
}

export enum EquationType {
  ResourceCalculations = 1,
  DrillingCalculations = 2,
  CompletionCalculations = 3,
  DrillingParametersCalculations = 4,
  CompletionsParametersCalculations = 5,
  PlannedDurations = 6,
  WellConnectCalculations = 7,
  ProjectPlanningCalculations = 8,
  DrillingProjectEstimateVariablesCalculations = 9,
  CompletionsProjectEstimateVariablesCalculations = 10,
  PadConstructionParametersCalculations = 11
}

export enum ProjectStatusDescription {
  Draft = "Draft",
  Preliminary = "Preliminary",
  Pending = "Pending",
  Active = "Active",
  Closing = "Closing",
  Closed = "Closed",
  Reactivated = "Reactivated",
  OnHold = "On Hold",
  Cancelled = "Cancelled"
}

export enum ProjectEstimateStatusDescription {
  Draft = "Draft",
  LatestPublished = "Latest Published",
  PreviouslyPublished = "Prev Published"
}